import Nav from './Nav'


function Pillar4() {
    let selectedPil="pillar ";
    let pillarHeading="";
    let pillar1Text="";
  
      selectedPil += " macroeconomic-response";
      pillarHeading = "Macroeconomic Response and Multilateral Collaboration";
      pillar1Text="COVID-19 is wreaking havoc on already weak economies. A three-step approach was taken: A rapid assessment of the potential impact of the crisis on economy, labour markets, sectors, human needs, along with its gender impacts, is needed in order to quantify the spending necessary to contain it. An assessment of the fiscal space available for increasing spending, as it will in large part determine the government’s capacity for action. An analysis of policy priorities and available policy measures considering both financing and implementation constraints faced by governments. ";
      return(
        <>
        <Nav active="p4" />
        <div className={selectedPil}>
                  <PillarStart text={pillar1Text} pilHeading={pillarHeading} />
                  <div className="customcontainer">
                    <TopKeyFigureSection active="p4" />
                    <Pillar4IndicatorSection heading="Companies/Workers Supported" indiNum="1" kfHeading="Companies" lineChart1Heading="Quarterly Progress (socioeconomic impact assessment)" lineChart2Heading ="Quarterly Progress (macro policies for at risk population)" />

                  </div>
                  <TableSection />
        </div>
        </>
      );

}

function TableSection()
{
  return(
    <div className="white-background">
      <div className="customcontainer">
          <div className="customrow">
              <div className="col-md-12">
                  <div className="title">
                      <div className="funded"></div>
                      <div className="text pillar">&nbsp;</div>
                  </div>
              </div>
              <table id="table" className="table table-hover"></table>
          </div>
      </div>
  </div>
  )
}

function PillarStart({text,pilHeading}){
    return (
      <div className="customcontainer">
                    <div className="topContent"><p>{text}</p></div>
                    <div className="customrow">
                        <div className="col-md-12">
                            <h1 className="pillar-title">
                                {pilHeading}
                            </h1>
                        </div>
                    </div>
                </div>
    )
  }

function TopKeyFigureSection({active})
{
    return(
        <div className="customrow">
          <div className="col-md-12">
            <div className="pillar4-blocks">
              <TopKeyFigure headingP1="SOCIO ECONOMIC IMPACT ASSESSMENT (SEIA)" headingP2="(# OF COUNTRIES)" div_id="1" />
              <TopKeyFigure headingP1="POLICIES INFORMED BY SEIAs" headingP2="(# OF COUNTRIES)" div_id="2" />
            </div>
          </div>
        </div>
      )
}

function TopKeyFigure({headingP1,headingP2, div_id})
{
  let divNAid="top-number"+div_id+"NA";
  let divID="top-number"+div_id;
  return(
    <div className="pillar-block">
      <div className="header">
      <div class="text text-center">
        {headingP1}
        </div>
        <div class="text text-center">
            {headingP2}
        </div>
      </div>
      <div className="body">
          <div className="counter text-center">
              <span id={divNAid}></span>
              <span id={divID}></span>
          </div>
      </div>
  </div>
  )
}


function IndKeyFigure({heading,div_id,unit})
{
  console.log(div_id);
  return(
    <>
      <div className="counter text-center">
        <span id={div_id} className="kf-number"></span>
      </div>
      <div className="title" style={{textAlign: 'center'}}>
          <div className="text">{heading}</div>
      </div>
    </>
  )
}


function Pillar4IndicatorSection({heading,indiNum,kfHeading,lineChart1Heading, lineChart2Heading}){
    let indDivID="Ind4."+indiNum;
    let kfDivID="number"+indiNum;
    let qrtChartID="";
    let rowChartID="";
    let qrtChartContainerID="";
    let qrtNAContainerID="";
    let rowChartContainerID="";
    let rowNAContainerID="";
          qrtChartID="chart1-4."+indiNum;
          rowChartID="chart2-4."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="4."+indiNum+"chart1NA";
          rowNAContainerID="4."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar macroeconomic-response">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>

              <div id={qrtChartID} className="col-md-6">
                <div className="funded">
                    <div className="title">
                        <div className="text">{lineChart1Heading}</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG4.1" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-6">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{lineChart2Heading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG4.2" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
  }
  
export default Pillar4;